module.exports = __webpack_public_path__ + "assets/img/leaf-hit.e70c296f.png";